import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query Wallet($userId: String!, $currency: String!, $entityId: ID, $entityType: WalletEntityType) {
    wallet(userId: $userId, entityId: $entityId, currency: $currency, entityType: $entityType) {
      availableBalance
      availableBalanceInCents
      scheduledInBalance
      currency
      uuid
      ownerUuid
      amount
    }
  }
`

export const toString = query.loc.source.body

export const walletQueryKey = getQueryNames(query)[0]

export default query
